import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormGroupDirective, UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Router } from '@angular/router';
import { NotificationHandlerComponent, StorageService } from '@ebootis/utilities';
import { ConfigurationService } from 'projects/zbs-app/src/app/components/configuration-select/configuration.service';
import { ErrorCodesI18n } from 'projects/zbs-app/src/app/i18n/ErrorCodesI18n';
import { ArticleBasketItemByOid } from 'projects/zbs-app/src/app/services/Ebootis.Queries/ArticleBasketItemByOid';
import { ArticleDetailsByOid } from 'projects/zbs-app/src/app/services/Ebootis.Queries/ArticleDetailsByOid';
import { ArticlePriceDetails } from 'projects/zbs-app/src/app/services/Ebootis.Queries/ArticlePriceDetails';
import { ArticleSearch } from 'projects/zbs-app/src/app/services/Ebootis.Queries/ArticleSearch';
import { CostCenters } from 'projects/zbs-app/src/app/services/Ebootis.Queries/CostCenters';
import { CustomerSearch } from 'projects/zbs-app/src/app/services/Ebootis.Queries/CustomerSearch';
import { DispatchDefinitions } from 'projects/zbs-app/src/app/services/Ebootis.Queries/DispatchDefinitions';
import { PaymentMethods } from 'projects/zbs-app/src/app/services/Ebootis.Queries/PaymentMethods';
import { UserInfos } from 'projects/zbs-app/src/app/services/Ebootis.Queries/UserInfos';
import { invoiceAddressesForPO } from 'projects/zbs-app/src/app/services/Ebootis.Queries/invoiceAddressesForPO';
import { IZbsApp } from 'projects/zbs-app/src/app/services/Ebootis.ServiceProxies/IZbsApp';
import { ZbsInvoiceCreation } from 'projects/zbs-app/src/app/services/Ebootis.Shared/ZbsInvoiceCreation';
import { ArticleBasketService, createFreeContingentValidator } from 'projects/zbs-app/src/app/services/article-basket.service';
import { EMPTY, Subject, concat, forkJoin, iif, merge, of } from 'rxjs';
import { catchError, defaultIfEmpty, distinctUntilChanged, finalize, map, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { ArticleService } from '../../../article/article.service';
import { OrderService } from '../../order.service';
@Component({
	selector: 'app-order-create',
	templateUrl: './order-create.component.html',
	styleUrls: ['./order-create.component.scss'],
	providers: [ErrorCodesI18n],
})
export class OrderCreateComponent implements OnInit, OnDestroy {

	get isVerificationCodeRequired(): boolean {
		let isRequired: boolean = false;
		if (this.m_authAmount != null && this.m_verificationCode != null && this.m_orderItems != null && this.m_orderItems.get(this.ITEMS) != null) {
			const items: any[] = this.m_orderItems.get(this.ITEMS).value;
			isRequired = items.findIndex((el) => el[this.PRICE] >= this.m_authAmount) >= 0;
		}
		return isRequired;
	}

	@ViewChild('deliveryFormDirective', { static: true }) public m_deliveryFormDirective: FormGroupDirective;
	@ViewChild('invoiceFormDirective', { static: true }) public m_invoiceFormDirective: FormGroupDirective;

	public readonly ORDER_ITEMS: string = 'orderItems';
	public readonly ITEMS: string = 'items';
	public readonly COST_CENTER: string = 'costCenter';
	public readonly ORDER_OPTIONS: string = 'orderOptions';
	public readonly SHOW_INVOICE_FORM: string = 'showInvoiceForm';
	public readonly DEVIANT_ADDRESS: string = 'deviantAddress';
	public readonly INVOICE_FORM: string = 'invoiceForm';
	public readonly DELIVERY_FORM: string = 'deliveryForm';
	public readonly ADDRESS_TYPE: string = 'addressType';
	public readonly ADDRESS_TYPE_CUSTOMER: string = 'customer';
	public readonly ADDRESS_TYPE_TO_ME: string = 'tome';
	public readonly ADDRESS_TYPE_PO: string = 'po';
	public readonly ADDRESS_TYPE_ONEWAY: string = 'oneway';
	public readonly ADDRESS: string = 'address';
	public readonly ADDRESS_OID: string = 'addressOid';
	public readonly CURRENCY: string = 'currency';
	public readonly DISPLAY_NAME: string = 'displayName';
	public readonly HAS_THUMB: string = 'hasThumb';
	public readonly OID: string = 'oid';
	public readonly QUANTITY: string = 'quantity';
	public readonly CUSTOMER: string = 'customer';
	public readonly FIX_DATE: string = 'fixDate';
	public readonly FIXED_DATE: string = 'fixedDate';
	public readonly VERIFICATION_CODE: string = 'vericicationCode';
	public readonly PRICE: string = 'price';
	public readonly PAYMENT_METHOD: string = 'paymentMethodProxyOid';
	public readonly PO_ID: string = 'poId';
	public readonly INFO_TEXT: string = 'infoText';
	public readonly CUSTOMER_INFO_TEXT: string = 'customerInfoText';
	public readonly IS_LOCKED_FOR_DELIVERY: string = 'isLockedForDelivery';
	public readonly AT_LEAST_ONE: string = 'atLeastOne';
	public readonly COMPANY_NAME_1: string = 'companyName1';
	public readonly COMPANY_NAME_2: string = 'companyName2';
	public readonly NAME: string = 'name';
	public readonly STREET: string = 'street';
	public readonly ZIP: string = 'zip';
	public readonly EMAIL: string = 'email';
	public readonly CITY: string = 'city';
	public readonly COUNTRY: string = 'country';
	public readonly COST_CENTER_OID: string = 'costCenterOid';
	public readonly SHIPPING_METHOD: string = 'shippingMethod';
	public readonly ARTICLE: string = 'article';
	public readonly QTTY: string = 'qtty';
	public readonly ZbsInvoiceCreation = ZbsInvoiceCreation;
	public readonly m_summaryColumns = ['article', 'price', 'amount', 'total'];
	public readonly FREE_CONTIGENT: string = 'freeContingent';
	public readonly ZBS_VALUE_LIST_ENTRY_OID: string = 'zbsValuelistEntryOid';


	private readonly m_subscriptionsSubject = new Subject();

	private readonly EMAIL_REGEX = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}';

	private m_txDef: string = '';
	private m_userCostCenter: string = '';
	public m_configInvoiceCreation: ZbsInvoiceCreation = ZbsInvoiceCreation.UNDEFINED;
	public m_isSetCostCenterAllowed: boolean = false;
	public m_invoiceAddressesForPO: invoiceAddressesForPO.Result[];
	public m_myAddress: UserInfos.Result;
	public m_selectedArticle: ArticleSearch.Article;
	public m_selectedArticleQtty: number;
	public m_articleFromBasket: ArticleBasketItemByOid.Result;
	public m_displayError: HttpErrorResponse;
	public m_displayMessage: string;
	public m_messageHandlerClass: string = 'info';
	public m_saveOrderClicked: boolean = false;
	public m_verificationCode: string = '';
	public m_authAmount: number;
	public m_myShippingMethod: DispatchDefinitions.Result;
	public m_shippingMethods: DispatchDefinitions.Result[];
	public m_paymentMethods: PaymentMethods.Result[];
	public m_invoiceForm: UntypedFormGroup;
	public m_deliveryForm: UntypedFormGroup;
	public m_orderOptions: UntypedFormGroup;
	public m_orderItems: UntypedFormGroup;
	public m_newItem: UntypedFormGroup;
	public m_articleSelectArticle: ArticleDetailsByOid.Result;
	public m_isSpecialorderPossible: boolean = false;
	public m_isFixdatePossible: boolean = false;
	public m_earliestDispatchDateDays: number = 0;
	public m_minDate: Date = new Date();
	public m_usedBudget: IZbsApp.UsedBudget;
	public m_simulatedOrder: IZbsApp.SimulatedOrder;
	public m_simulateLoading: boolean = false;
	private m_noInvoiceWithoutValue: boolean = false;
	public m_calculatedOrderValue: number;
	public m_showInvoiceForm: boolean;
	public m_valuelistMandatory: boolean;
	public m_valuelistEnabled: boolean;

	public m_configOid: string;

	constructor(
		private m_fb: UntypedFormBuilder,
		private m_cfgService: ConfigurationService,
		private m_orderService: OrderService,
		private m_costCenters: CostCenters,
		private m_addressOfLogonUser: UserInfos,
		private m_invoiceAddressForPOQuery: invoiceAddressesForPO,
		//private m_invoiceAddressQuery: InvoiceAddressesOfCompanyCustomer,
		//private m_deliveryAddressQuery: DeliveryAddressesOfCompanyCustomer,
		private m_articlePriceQuery: ArticlePriceDetails,
		private m_articleService: ArticleService,
		private paymentMethodQuery: PaymentMethods,
		private m_router: Router,
		private m_snackBar: MatSnackBar,
		public m_basketService: ArticleBasketService,
		private m_zbs: IZbsApp,
		private changeDetector: ChangeDetectorRef,
		private storageService: StorageService
	) {
		this.m_configOid = this.m_cfgService.SelectedConfigOid;
		this.m_invoiceForm = this.m_fb.group({
			[this.SHOW_INVOICE_FORM]: [false],
			[this.DEVIANT_ADDRESS]: [false],
			[this.PAYMENT_METHOD]: [''],
			[this.PO_ID]: [''],
			[this.ADDRESS_TYPE]: [this.ADDRESS_TYPE_ONEWAY],
			[this.ADDRESS_OID]: [''],
			[this.CUSTOMER]: [''],
			[this.ADDRESS]: this.m_fb.group({
				[this.AT_LEAST_ONE]: this.m_fb.group({
					[this.COMPANY_NAME_1]: [''],
					[this.COMPANY_NAME_2]: [''],
					[this.NAME]: [''],
				}, { validators: this.invoiceFormAtLeastOne.bind(this) }),
				[this.STREET]: ['', this.invoiceFormRequired.bind(this)],
				[this.ZIP]: ['', this.invoiceFormRequired.bind(this)],
				[this.EMAIL]: ['', [this.invoiceFormRequired.bind(this), Validators.pattern(this.EMAIL_REGEX)]],
				[this.CITY]: ['', this.invoiceFormRequired.bind(this)],
				[this.COUNTRY]: ['', this.invoiceFormRequired.bind(this)],
			}),
		});
		this.m_deliveryForm = this.m_fb.group({
			[this.COST_CENTER]: [''],
			[this.COST_CENTER_OID]: [''],
			[this.ADDRESS_TYPE]: [this.ADDRESS_TYPE_ONEWAY],
			[this.ADDRESS_OID]: [''],
			[this.CUSTOMER]: [''],
			[this.ADDRESS]: this.m_fb.group({
				[this.AT_LEAST_ONE]: this.m_fb.group({
					[this.COMPANY_NAME_1]: [''],
					[this.COMPANY_NAME_2]: [''],
					[this.NAME]: [''],
				}, { validators: this.atLeastOneValidator.bind(this) }),
				[this.STREET]: ['', Validators.required],
				[this.ZIP]: ['', Validators.required],
				[this.EMAIL]: ['', [Validators.required, Validators.pattern(this.EMAIL_REGEX)]],
				[this.CITY]: ['', Validators.required],
				[this.COUNTRY]: ['', Validators.required],
			}),
		});

		this.m_orderOptions = this.m_fb.group({
			[this.FIXED_DATE]: [false],
			[this.FIX_DATE]: [null, this.fixDateRequired.bind(this)],
			[this.SHIPPING_METHOD]: [, Validators.required],
			[this.IS_LOCKED_FOR_DELIVERY]: [false],
			[this.INFO_TEXT]: [''],
			[this.CUSTOMER_INFO_TEXT]: [''],
			[this.VERIFICATION_CODE]: [{ value: '', disabled: false }, [this.verificationCodeRequired.bind(this)]],
			[this.ZBS_VALUE_LIST_ENTRY_OID]: ['']
		});

		this.m_orderItems = this.m_fb.group({
			[this.ITEMS]: this.m_fb.array([], [this.atLeastOneItemValidator.bind(this)]),
		});

		this.m_newItem = this.m_fb.group({
			[this.ARTICLE]: ['', Validators.required],
			[this.QTTY]: ['1', Validators.required]
		});
		merge(this.m_invoiceForm.valueChanges, this.m_deliveryForm.valueChanges, this.m_orderOptions.valueChanges).subscribe({
			next: (changed) => {
				this.clearDisplayMessages();
			}
		})
		this.setQuantityValidators();
	}

	/**
	 * Die Adresse des angemeldeten Benutzers, die Liefer- sowie Rechnungsadresse und die Konfiguration werden geladen.
	 */
	public ngOnInit(): void {
		forkJoin({
			address: this.m_addressOfLogonUser.query(),
			invoiceAddressForPO: this.m_invoiceAddressForPOQuery.query(),
			paymentMethods: this.paymentMethodQuery.query({ config: this.m_cfgService.SelectedConfigOid })
		})
			.pipe(tap(({ address, invoiceAddressForPO, paymentMethods }) => {
				this.m_myAddress = address;
				if (this.m_myAddress?.email && !this.m_myAddress.address) {
					this.getControl(this.m_deliveryForm, `${this.ADDRESS}.${this.EMAIL}`).setValue(this.m_myAddress.email);
					this.getControl(this.m_invoiceForm, `${this.ADDRESS}.${this.EMAIL}`).setValue(this.m_myAddress.email);
				}
				this.m_invoiceAddressesForPO = invoiceAddressForPO;
				this.setCountry(this.m_invoiceForm, this.m_invoiceAddressesForPO);
				this.setCountry(this.m_invoiceForm);
				this.setCountry(this.m_deliveryForm);
				this.m_paymentMethods = paymentMethods;
			}))
			.pipe(switchMap(() => iif(() => this.m_paymentMethods?.some((pm => pm.isForBudget == true)), this.m_zbs.getUsedBudget(), EMPTY))) // Redmine #12454
			.pipe(takeUntil(this.m_subscriptionsSubject))
			.subscribe({
				next: (budget) => {
					this.m_usedBudget = budget;
				}
			});
		this.m_cfgService.getConfiguration().pipe(
			takeUntil(this.m_subscriptionsSubject),
		).subscribe({
			next: (configuration) => {
				if (configuration) {
					this.m_txDef = configuration.txDefOrder.oid;
					this.m_configInvoiceCreation = configuration.invoiceCreation; // ENUM JA,NEIN,DFLT_YES,DFLT_NEIN
					this.m_noInvoiceWithoutValue = configuration.noInvoiceWithoutValue;
					// wenn invoiceCreation den Wert Ja oder DFLT_JA hat, soll das Rechungsadressen-Formular angezeigt werden, showInvoiceForm ist im Tmplt eine Checkbox
					this.setDefaultInvoiceValues();
					this.m_isSetCostCenterAllowed = configuration.isSetCostCenterAllowed;

					this.m_userCostCenter = configuration.userCostCenter;
					this.m_verificationCode = configuration.verificationCode;
					this.m_authAmount = configuration.authAmount;

					this.m_valuelistMandatory = configuration.valuelistMandatory;
					this.m_valuelistEnabled = configuration.valuelistEnabled;
					// kann und sollte nur als Pflichtfeld markiert werden, wenn auch wirklich aktiv und Pflicht sein soll
					// über Anwendung ZBS-Konfiguration kann es aktiviert/deaktiviert werden aber Flag ob Pflichtangabe ist kann natürlich noch aktiv sein ;)
					if (this.m_valuelistMandatory && this.m_valuelistEnabled)
						this.m_orderOptions.get(this.ZBS_VALUE_LIST_ENTRY_OID).addValidators(Validators.required);

					this.m_minDate = new Date();
					this.m_earliestDispatchDateDays = configuration.minFixDateDayOffset;
					this.m_minDate.setDate(this.m_minDate.getDate() + this.m_earliestDispatchDateDays);
					this.m_orderOptions.get(this.FIX_DATE).setValue(this.m_minDate);
					// erst nachdem configuration geladen wurde deserialisieren, da sonst showInvoiceForm überschrieben wird.
					this.deserializeForm(this.DELIVERY_FORM, this.m_deliveryForm);
					this.m_deliveryForm.get(this.COST_CENTER).setAsyncValidators(this.costCenterValid.bind(this));
					this.deserializeForm(this.INVOICE_FORM, this.m_invoiceForm);
					this.deserializeForm(this.ORDER_OPTIONS, this.m_orderOptions);
					if (this.FIX_DATE)
						this.m_isFixdatePossible = configuration.showFixDate;
					if (!this.m_isFixdatePossible)
						this.m_orderOptions.get(this.FIXED_DATE).disable();
					else
						this.m_orderOptions.get(this.FIXED_DATE).enable();
					this.m_isSpecialorderPossible = configuration.showSpecialOrder;
					if (!this.m_isSpecialorderPossible)
						this.m_orderOptions.get(this.IS_LOCKED_FOR_DELIVERY).disable();
					else
						this.m_orderOptions.get(this.IS_LOCKED_FOR_DELIVERY).enable();
					this.m_orderService.getDispatchDefinitions({ config: this.m_cfgService.SelectedConfigOid }).pipe(
						takeUntil(this.m_subscriptionsSubject),
					).subscribe({
						next: (res: DispatchDefinitions.Result[]) => {
							this.m_shippingMethods = res;
							if (this.m_orderOptions.get('shippingMethod').value) {
								const oid = this.m_orderOptions.get('shippingMethod').value;
								this.m_myShippingMethod = this.m_shippingMethods?.find((item) => item.oid == oid);
							} else if (this.m_shippingMethods?.length == 1) {
								this.getControl(this.m_orderOptions, this.SHIPPING_METHOD).setValue(this.m_shippingMethods[0].oid);
								this.shippingMethodSelected(this.m_shippingMethods[0].oid)
							}
						},
					});

				}
			},
		});
		this.getBasketItems();
	}

	public paymentMethodSelected(p_paymentMethod: string) {
		this.clearDisplayMessages();
		const selectedPaymentMethod = this.m_paymentMethods.find((el) => el.oid == p_paymentMethod);
		if (selectedPaymentMethod.isForPO) {
			this.m_invoiceForm.get(this.DEVIANT_ADDRESS).setValue(true);
			this.m_invoiceForm.get(this.ADDRESS_TYPE).setValue(this.ADDRESS_TYPE_PO);
			this.invoiceAddressTypeChanged();
			if (this.m_invoiceAddressesForPO?.length == 1) {
				this.m_invoiceForm.get(this.ADDRESS_OID).setValue(this.m_invoiceAddressesForPO[0].oid);
				this.setAddressByOid(this.m_invoiceForm.get(this.ADDRESS), this.m_invoiceAddressesForPO[0].oid);
			}
		} else {
			this.m_invoiceForm.get(this.DEVIANT_ADDRESS).setValue(false);
			this.m_invoiceForm.get(this.ADDRESS_TYPE).setValue(this.ADDRESS_TYPE_TO_ME);
			this.invoiceAddressTypeChanged();
		}
	}

	getSelectedPaymentMethod() {
		return this.m_paymentMethods && this.m_invoiceForm.get(this.PAYMENT_METHOD).value ? this.m_paymentMethods.find((el) => el.oid == this.m_invoiceForm.get(this.PAYMENT_METHOD).value) : null;
	}

	public onArticleChanged(p_article: ArticleDetailsByOid.Result) {
		this.m_articleSelectArticle = p_article;
		this.setQuantityValidators();

		if (p_article) {
			const salesAmountMin = this.m_articleSelectArticle.salesAmountMin || 1;
			this.m_newItem.get(this.QTTY).patchValue(salesAmountMin);
			this.m_newItem.get(this.QTTY).markAsTouched();
		}
	}

	public setQuantityValidators(): void {
		let validators: any[] = [Validators.required];

		if (this.m_articleSelectArticle) {
			const salesAmountMax = this.m_articleSelectArticle.salesAmountMax;
			const salesAmountMin = this.m_articleSelectArticle.salesAmountMin || 1;
			const availableNow = this.m_articleSelectArticle.availableNow;
			// this.m_newItem.get(this.QTTY).setValue(salesAmountMin);
			validators.push(Validators.min(salesAmountMin));
			if (this.m_articleSelectArticle.onlyAvailableStock) {
				// den kleineren der beiden Werte als Maximalwert setzen
				if (salesAmountMax && salesAmountMax < availableNow) {
					validators.push(Validators.max(salesAmountMax));
				} else {
					if (this.m_articleSelectArticle.availableNow === 0 && this.m_articleSelectArticle.freeContingent > 0)
						validators.push(Validators.max(this.m_articleSelectArticle.freeContingent));
					else if (this.m_articleSelectArticle.availableNow < this.m_articleSelectArticle.freeContingent)
						validators.push(Validators.max(this.m_articleSelectArticle.freeContingent));
					else
						validators.push(Validators.max(availableNow));
				}
			}
			if (this.m_articleSelectArticle?.freeContingent != undefined)
				validators.push(createFreeContingentValidator(this.m_articleSelectArticle.freeContingent));
		}

		this.m_newItem.get(this.QTTY).setValidators(validators);
	}

	public getMinimumAmountError(p_amount: number): string {
		return this.m_basketService.getMinimumAmountError(p_amount);
	}

	public getMaximumAmountError(p_amount: number): string {
		return this.m_basketService.getMaximumAmountError(p_amount);
	}

	/**
	 * Setzt die Länderauswahl des Formulars auf das Land des Users
	 * oder auf das des Mandanten, wobei das des Users
	 * Vorrang hat. Hat weder Mandant noch User eine
	 * Adresse, wird standardmäßig Deutschland als Land gewählt.
	 */
	private setCountry(p_formGroup: UntypedFormGroup, p_addressArray?: any[]) {
		let country = 'DE';
		if (p_addressArray) {
			let address = p_addressArray.find(address => address.default === true) || p_addressArray[0];
			if (address.country) {
				country = address.country;
			}
		}

		if (this.m_myAddress && this.m_myAddress.address && this.m_myAddress.address.countryIso) {
			country = this.m_myAddress.address.countryIso;
		}
		p_formGroup.get('address').patchValue({ country: country });
	}


	/**
	 * Die Subscriptions werden geschlossen.
	 */
	public ngOnDestroy(): void {
		this.m_subscriptionsSubject.next(null);
		this.m_subscriptionsSubject.complete();
	}
	private getIsInvoiceFormRequired() {
		if (this.m_invoiceForm) {
			const showInvoiceFormCtrl = this.m_invoiceForm.get(this.SHOW_INVOICE_FORM);
			const deviantAddressCtrl = this.m_invoiceForm.get(this.DEVIANT_ADDRESS);
			const paymentMethodCtrl = this.m_invoiceForm.get(this.PAYMENT_METHOD);
			const selectedPaymentMethod = this.m_paymentMethods?.find((el) => el.oid == paymentMethodCtrl.value);
			// return showInvoiceFormCtrl && showInvoiceFormCtrl.value && deviantAddressCtrl && deviantAddressCtrl.value && paymentMethodCtrl && selectedPaymentMethod && (!selectedPaymentMethod || !selectedPaymentMethod.isForPO);
			// #11486
			return showInvoiceFormCtrl?.value && deviantAddressCtrl?.value;
		} else return false;
	}
	private invoiceFormRequired: ValidatorFn = (p_control: AbstractControl) => {
		let result = null;
		if (this.getIsInvoiceFormRequired() && (!p_control.value || p_control.value == ''))
			result = { required: true };
		return result;
	}

	public atLeastOneValidator: ValidatorFn = (p_control: UntypedFormGroup): ValidationErrors | null => {
		const controls = p_control.controls;
		if (controls) {
			const foundIndex = Object.keys(controls).findIndex((key) => controls[key].value && controls[key].value != '');
			if (foundIndex === -1) {
				return { atLeastOneRequired: true };
			}
		}
	}

	public atLeastOneItemValidator: ValidatorFn = (p_control: UntypedFormArray): ValidationErrors | null => {
		const controls = p_control.controls;
		if (!p_control.controls || p_control.controls.length <= 0)
			return { atLeastOneItemRequired: true };
		else return null;
	}

	public invoiceFormAtLeastOne: ValidatorFn = (p_control: UntypedFormGroup): ValidationErrors | null => {
		let isInvoiceAddressRequired = this.getIsInvoiceFormRequired();
		return isInvoiceAddressRequired && this.atLeastOneValidator(p_control) ? { atLeastOneRequired: true } : null;
	}

	public isOneWayAddress(p_form: UntypedFormGroup): boolean {
		return p_form.get(this.ADDRESS_TYPE).value == this.ADDRESS_TYPE_ONEWAY
			|| p_form.get(this.ADDRESS_TYPE).value == this.ADDRESS_TYPE_CUSTOMER
			|| p_form.get(this.ADDRESS_TYPE).value == this.ADDRESS_TYPE_TO_ME
			|| p_form.get(this.ADDRESS_TYPE).value === this.ADDRESS_TYPE_PO;
	}

	public isInvoiceAddressFieldRequired(): boolean {
		return this.getIsInvoiceFormRequired();
	}

	public showClearInputButton(p_form: UntypedFormGroup, p_formControlName: string): boolean {
		return this.isOneWayAddress(p_form) && this.getControl(p_form, p_formControlName).value && this.getControl(p_form, p_formControlName).enabled;
	}

	private costCenterValid: AsyncValidatorFn = (p_control: AbstractControl) => {
		if (p_control.value != null && p_control.value != '') {
			let theObserver = this.m_costCenters.query({ searchName: p_control.value });
			theObserver = theObserver.pipe(defaultIfEmpty({ invalid: true } as any));
			theObserver = theObserver.pipe(map((arr) => arr != null && arr.length == 1 ? this.m_deliveryForm.get('costCenterOid').setValue(arr[0].oid) : ({ invalid: true } as any)));
			return theObserver;
		} else {
			return of(null);
		}
	}

	private fixDateRequired: ValidatorFn = (p_control: AbstractControl) => {
		return this.m_orderOptions ? this.m_orderOptions.get(this.FIX_DATE).value && (p_control.value == null || p_control.value == '') ? { required: true } : null : null;
	}

	private verificationCodeRequired: ValidatorFn = (p_control: AbstractControl) => {
		return this.m_orderOptions && this.isVerificationCodeRequired && this.m_verificationCode && new RegExp(this.m_verificationCode).test(p_control.value) === false ? { required: true } : null;
	}

	/**
	 * Setzt Rechnungsadresse = Lieferadresse falls Checkbox 'abweichende Lieferadresse' nicht aktiviert.
	 */
	public checkDeviantAddress(): void {
		if (this.m_invoiceForm.get(this.DEVIANT_ADDRESS).value == false) {
			this.m_invoiceForm.get(this.ADDRESS_OID).setValue(this.m_deliveryForm.get(this.ADDRESS_OID).value);
			this.m_invoiceForm.get(this.CUSTOMER).setValue(this.m_deliveryForm.get(this.CUSTOMER).value)
			this.m_invoiceForm.get(this.ADDRESS).patchValue(this.m_deliveryForm.get(this.ADDRESS).value);
		}
	}

	/**
	 * Setzt bei einer Änderung die Validatoren sowie die atLeastOne Form zurück.
	 * @param p_formGroup Adressformular (invoice)
	 */
	public invoiceChanged(p_formGroup: UntypedFormGroup): void {
		this.m_showInvoiceForm = this.getControl(p_formGroup, this.SHOW_INVOICE_FORM).value;
		this.getControl(this.m_invoiceForm, this.PAYMENT_METHOD).reset();
		if (this.getControl(p_formGroup, this.SHOW_INVOICE_FORM).value) {
			this.getControl(p_formGroup, this.PAYMENT_METHOD).setValidators(Validators.required);
			if (this.m_paymentMethods?.length == 1) {
				this.getControl(this.m_invoiceForm, this.PAYMENT_METHOD).setValue(this.m_paymentMethods[0].oid);
				this.paymentMethodSelected(this.m_paymentMethods[0].oid);
			}
		} else {
			this.getControl(p_formGroup, this.PAYMENT_METHOD).clearValidators();
			p_formGroup.get(this.PAYMENT_METHOD).setErrors(null);
			if (this.m_myAddress?.address)
				this.getControl(this.m_invoiceForm, this.ADDRESS_TYPE).setValue(this.ADDRESS_TYPE_TO_ME);
		}
		this.invoiceAddressTypeChanged();
		this.changeDetector.detectChanges();
		p_formGroup.get(this.PAYMENT_METHOD).updateValueAndValidity();
		p_formGroup.updateValueAndValidity({ onlySelf: false });
	}

	/**
	 * Setzt die Adressfelder innerhalb von address UND addressOid,customer zurück.
	 * @param p_formGroup das Adressformular (invoice/delivery)
	 */
	public addressTypeChanged(p_formGroup: UntypedFormGroup): void {
		this.clearDisplayMessages();
		let selectedCountry = p_formGroup.get(this.ADDRESS).get(this.COUNTRY).value;
		p_formGroup.get(this.ADDRESS_OID).reset(null);
		p_formGroup.get(this.CUSTOMER).reset(null);
		p_formGroup.get(this.ADDRESS).reset({ [this.COUNTRY]: selectedCountry });
		p_formGroup.updateValueAndValidity();
		this.changeDetector.detectChanges();
	}

	public deliveryAddressTypeChanged() {
		this.addressTypeChanged(this.m_deliveryForm);
		const addressType = this.m_deliveryForm.get(this.ADDRESS_TYPE).value;
		if (addressType == this.ADDRESS_TYPE_TO_ME) {
			if (this.m_myAddress?.address) {
				this.getControl(this.m_deliveryForm, this.ADDRESS_OID).setValue(this.m_myAddress.address.oid);
				this.setAddressByOid(this.m_deliveryForm.get(this.ADDRESS), this.m_myAddress.address.oid);
			}
		} else if (addressType == this.ADDRESS_TYPE_ONEWAY && !this.m_myAddress.address) {
			this.getControl(this.m_deliveryForm, `${this.ADDRESS}.${this.EMAIL}`).setValue(this.m_myAddress.email);
		}

	}

	public invoiceAddressTypeChanged() {
		this.addressTypeChanged(this.m_invoiceForm);
		const addressType = this.getControl(this.m_invoiceForm, this.ADDRESS_TYPE).value;
		if (addressType == this.ADDRESS_TYPE_TO_ME) {
			if (this.m_myAddress?.address) {
				this.getControl(this.m_invoiceForm, this.ADDRESS_OID).setValue(this.m_myAddress.address.oid);
				this.setAddressByOid(this.m_invoiceForm.get(this.ADDRESS), this.m_myAddress.address.oid);
			}
		} else if (addressType == this.ADDRESS_TYPE_ONEWAY) {
			if (this.m_myAddress?.email && !this.m_myAddress?.address)
				this.getControl(this.m_invoiceForm, `${this.ADDRESS}.${this.EMAIL}`).setValue(this.m_myAddress.email);
		} else if (this.getControl(this.m_invoiceForm, this.ADDRESS_TYPE).value == this.ADDRESS_TYPE_PO) {
			if (this.m_invoiceAddressesForPO?.length == 1) {
				this.getControl(this.m_invoiceForm, this.ADDRESS_OID).setValue(this.m_invoiceAddressesForPO[0].oid);
				this.setAddressByOid(this.m_invoiceForm.get(this.ADDRESS), this.m_invoiceAddressesForPO[0].oid);
			}
		}

	}

	/**
	 * Liefert die Elemente des OrderItem Arrays zurück.
	 * @returns Elemente des OrderItem Arrays
	 */
	public getArray(): AbstractControl[] {
		return (this.m_orderItems.get(this.ITEMS) as UntypedFormArray).controls;
	}

	/**
	 * Nimmt ein OrderItem Element entgegen, setzt Preis und Währung, aktualisiert LocalStorage Menge.
	 * @param p_orderItemFG OrderItem FormGroup welche berechnet werden soll
	 */
	public getPriceAndAdjustQtty(p_orderItemFG: AbstractControl): void {
		if (this.m_txDef) {
			this.m_articlePriceQuery.query({ article: p_orderItemFG.get(this.ARTICLE).value, config: this.m_cfgService.SelectedConfigOid, quantity: p_orderItemFG.get(this.QUANTITY).value }).pipe(
				takeUntil(this.m_subscriptionsSubject),
			).subscribe({
				next: (value) => {
					// fehlt das nicht?! p_orderItemFG.get(this.QUANTITY).setValue(value.quantity ? value.quantity : 0);
					p_orderItemFG.get(this.PRICE).setValue(value.customerPrice ? value.customerPrice : 0);
					p_orderItemFG.get(this.CURRENCY).setValue(value.currencyCode ? value.currencyCode : '€');
					this.m_basketService.updateArticleLocalStorageQuantity(p_orderItemFG.get(this.ARTICLE).value, p_orderItemFG.get(this.QUANTITY).value);
				},
			});
		}
	}

	/**
	 * Summiert die Elemente des OrderItem Array auf.
	 * @returns Summe der OrderItem Elemente
	 */
	public getSum(): number {
		let sum = 0;
		if (this.m_calculatedOrderValue)
			sum = this.m_calculatedOrderValue;
		else if (this.m_simulatedOrder?.orderValue) {
			sum = this.m_simulatedOrder.orderValue
		} else {
			this.getArray().forEach((element) => {
				sum += this.getOrderItemValue(element);
			});
		}

		return sum;
	}

	public getRemainingBudget(): number {
		let budget = 0;
		if (this.m_usedBudget) {
			budget = this.m_usedBudget.budget - this.m_usedBudget.usedBudget;
			if (budget < 0)
				budget = 0;
		}
		return budget;
	}

	public isPaymentMethodBudgetAndDisabled(p_method: PaymentMethods.Result): boolean {
		return p_method.isForBudget && this.getRemainingBudget() <= 0;
	}

	/**
	 * Liefert den Gesamtpreis eines OrderItem Elementes zurück.
	 * @param p_item OrderItem welches berechnet werden soll
	 * @returns Gesamtpreis des Elementes
	 */
	public getOrderItemValue(p_item: AbstractControl): number {
		return p_item.value.quantity * p_item.value.price;
	}

	/**
	 * Erstellt ein neues OrderItem Element. Validatoren werden gesetzt.
	 * @param p_orderItem Artikel welcher hinzugefügt werden soll
	 * @returns FormGroup des Artikels welcher in OrderItems hinzugefügt wird
	 */
	private createOrderItemFormGroup(p_orderItem?: ArticleBasketItemByOid.Result): UntypedFormGroup {
		// Validatoren werden vor erstellen der FormGroup zusammengebaut. Validator min wird in jedem Fall gesetzt.

		return this.m_fb.group({
			[this.ARTICLE]: [p_orderItem.oid, Validators.required],
			[this.DISPLAY_NAME]: [p_orderItem.id + ' ' + (p_orderItem.descrLong ? p_orderItem.descrLong : '')],
			[this.QUANTITY]: [p_orderItem.quantity, this.m_basketService.getQuantityValidators(p_orderItem)],
			[this.PRICE]: [p_orderItem.customerPrice ? p_orderItem.customerPrice : 0],
			[this.CURRENCY]: [p_orderItem.currencyCode ? p_orderItem.currencyCode : '€'],
			[this.HAS_THUMB]: [p_orderItem.hasThumb],
			[this.OID]: [p_orderItem.oid],
			[this.FREE_CONTIGENT]: [p_orderItem.freeContingent],
		});
	}

	/**
	 * Entfernt das OrderItem Element an der angegebenen Stelle.
	 * @param p_index Index des Elementes
	 */
	public removeOrderItem(p_index: number): void {
		(this.m_orderItems.get(this.ITEMS) as UntypedFormArray).removeAt(p_index);
		this.m_basketService.removeBasketItem(this.m_selectedArticle.oid);
		this.m_selectedArticle = null;
		this.m_simulatedOrder = null;
	}

	/**
	 * Fügt ein OrderItem Element ans Ende hinzu.
	 */
	public async addOrderItem_Click(): Promise<void> {
		await this.m_basketService.saveBasketItem(this.m_newItem.value.article, this.m_cfgService.SelectedConfigOid, this.m_newItem.value.qtty)
			.then((selectedArticle) => {
				this.m_newItem.reset({ [this.QTTY]: 1 });
				this.m_newItem.clearValidators();
				this.m_newItem.get(this.QTTY).clearValidators();
				this.m_newItem.get(this.QTTY).setErrors(null);
				this.m_simulatedOrder = null;
				this.m_newItem.updateValueAndValidity({ onlySelf: false });
				this.changeDetector.detectChanges();
			})
			.catch((error: Error) => {
				this.m_snackBar.openFromComponent(NotificationHandlerComponent, {
					data: {
						message: error.message,
						type: 'danger',
					},
					duration: 2000,
				});
			});
	}

	/**
	 * Liefert ein FormControl zurück.
	 * @param p_form FormGroup des Controls welches zurückgegeben werden soll
	 * @param p_ctrlName Name des Controls welches zurückgegeben werden soll
	 * @returns FormControl welches per FormGroup und Name bestimmt wird
	 */
	public getControl(p_form: UntypedFormGroup, p_ctrlName: string): AbstractControl {
		return p_form ? p_form.get(p_ctrlName) : null;
	}

	/**
	 * Sollte das nicht ein Setter sein?
	 * @param p_article Artikel aus Artikelsuche
	 */
	public setSelectedArticleOid(p_article: ArticleSearch.Article) {
		this.m_selectedArticle = p_article;
	}

	/**
	 * Setzt die Adresse falls eigene Adresse angegeben wurde.
	 * @param p_form FormGroup Liefer/Rechnungsadresse
	 * @param p_entry GUID der selektierten Adresse
	 */
	public setAddressByOid(p_form: AbstractControl, p_entry: string) {
		if (this.m_myAddress != null && this.m_myAddress.address != null && this.m_myAddress.address.oid == p_entry) {
			let alternateNameLines: string[] = [];
			let fullName = `${this.m_myAddress.firstName ? this.m_myAddress.firstName : ''} ${this.m_myAddress.lastName ? this.m_myAddress.lastName : ''}`;
			if (this.m_myAddress?.address?.alternateName)
				alternateNameLines = this.getAlternateName(this.m_myAddress.address.alternateName);
			p_form.patchValue({
				atLeastOne: {
					companyName1: alternateNameLines?.length > 0 ? alternateNameLines[0] : fullName,
					//wenn nur eine Zeile gesetzt ist, soll keine Leerzeile zwischen alt. Name und Vor-/Nachname entstehen
					companyName2: alternateNameLines?.length > 1 ? alternateNameLines[1] : alternateNameLines.length > 0 ? fullName : '',
					name: alternateNameLines?.length > 1 ? fullName : '',
				},
				street: this.m_myAddress.address.street,
				zip: this.m_myAddress.address.zip,
				email: this.m_myAddress.email,
				city: this.m_myAddress.address.city,
				country: this.m_myAddress.address.countryIso,
			});
		} else {
			let addresses = [];
			let address;
			let poAddress = false;
			if (this.m_invoiceAddressesForPO != null) {
				addresses.push(...this.m_invoiceAddressesForPO);
				address = this.m_invoiceAddressesForPO.find((val) => val.oid == p_entry);
				if (address)
					poAddress = true; //bei Adresse == PO email aus Adresse verwenden
			}
			if (!address)
				address = addresses.find((val) => val.oid == p_entry);
			if (address) {
				let alternateNameLines: string[] = [];
				if (address.alternateName)
					alternateNameLines = this.getAlternateName(address.alternateName);
				p_form.patchValue({
					atLeastOne: {
						companyName1: address.alternateName ? alternateNameLines[0] ? alternateNameLines[0] : '' : address.name1,
						companyName2: address.alternateName ? alternateNameLines[1] ? alternateNameLines[1] : '' : address.name2 || '',
						name: address.alternateName ? alternateNameLines[2] ? alternateNameLines[2] : '' : '',
					},
					street: address.street,
					zip: address.zip,
					email: poAddress ? address.email : this.m_myAddress.email,
					city: address.city,
					country: address.country,
				});
			}
		}
	}
	private getOrderValue() {
		this.m_simulateLoading = true;
		this.m_zbs.getOrderValueWithoutFreightage(this.getOrderStruct())
			.pipe(take(1))
			.pipe(finalize(() => { this.m_simulateLoading = false }))
			.subscribe({
				next: (value) => {
					this.m_calculatedOrderValue = value;
					this.setDefaultInvoiceValues();
					this.changeDetector.detectChanges();
				}
			})
	}

	private setDefaultInvoiceValues() {
		this.m_invoiceForm.get(this.SHOW_INVOICE_FORM).setValue(this.m_configInvoiceCreation == ZbsInvoiceCreation.YES || this.m_configInvoiceCreation == ZbsInvoiceCreation.CHOICE_DFLT_YES);
		if (this.m_calculatedOrderValue <= 0 && this.m_noInvoiceWithoutValue)
			this.m_invoiceForm.get(this.SHOW_INVOICE_FORM).setValue(false);
		if (this.m_configInvoiceCreation == ZbsInvoiceCreation.YES || this.m_configInvoiceCreation == ZbsInvoiceCreation.NO || (this.m_calculatedOrderValue <= 0 && this.m_noInvoiceWithoutValue))
			this.m_invoiceForm.get(this.SHOW_INVOICE_FORM).disable();
		else
			this.m_invoiceForm.get(this.SHOW_INVOICE_FORM).enable();
		this.invoiceChanged(this.m_invoiceForm);
		this.changeDetector.detectChanges();
	}

	public onLeaveStep(p_selectionEvent: StepperSelectionEvent): void {
		// wenn eine Rechnungsaddresse angegeben werden muss, haben wir fünf Steps statt nur vier
		const invoiceCreation: boolean = this.m_configInvoiceCreation != ZbsInvoiceCreation.NO && this.m_configInvoiceCreation != ZbsInvoiceCreation.UNDEFINED

		if (p_selectionEvent.previouslySelectedIndex == 0) {
			this.getOrderValue();
		} else if (p_selectionEvent.previouslySelectedIndex == 1) {
			// Lieferadresse-Step
			this.checkDeviantAddress();
			this.serializeForm(this.DELIVERY_FORM, this.m_deliveryForm);
		} else if (p_selectionEvent.previouslySelectedIndex == 2 && invoiceCreation) {
			// Rechnungsadresse-Step
			this.serializeInvoiceForm();
		}

		if (p_selectionEvent.selectedIndex == 4 || (!invoiceCreation && p_selectionEvent.selectedIndex == 3)) {
			//optionen Step
			this.simulateOrder_Click();
		}
	}

	/**
	 * Übernimmt die Rechnungsadresse und serialisiert sie.
	 */
	public serializeInvoiceForm(): void {
		this.checkDeviantAddress();
		this.serializeForm(this.INVOICE_FORM, this.m_invoiceForm);
	}

	/**
	 * Setzt die Adresse falls Kundenadresse angegeben wurde
	 * @param p_form FormGroup Liefer/Rechnungsadresse
	 * @param p_selectedCustomer der ausgewählte Kunde, dessen Adresse verwendet werden soll
	 */
	public setAddressByCustomer(p_form: UntypedFormGroup, p_selectedCustomer?: CustomerSearch.Customer) {
		if (p_selectedCustomer) {
			p_form.get(this.ADDRESS).patchValue({
				atLeastOne: {
					companyName1: `${p_selectedCustomer.companyName1 ? p_selectedCustomer.companyName1 : ''}`,
					companyName2: `${p_selectedCustomer.companyName2 ? p_selectedCustomer.companyName2 : ''}`,
					name: `${(p_selectedCustomer.title ? (p_selectedCustomer.title + ' ') : '') + (p_selectedCustomer.firstName ? (p_selectedCustomer.firstName + ' ') : '') + (p_selectedCustomer.lastName ? p_selectedCustomer.lastName : '')}`,
				},
				street: p_selectedCustomer.street,
				zip: p_selectedCustomer.zip,
				email: p_selectedCustomer.email ? p_selectedCustomer.email : '',
				city: p_selectedCustomer.city,
				country: p_selectedCustomer.country,
			});
		} else {
			this.addressTypeChanged(p_form);
		}
	}

	/**
	 * Erstellt ein JSON-Objekt aus einer FormGroup.
	 * @param p_formName Name der FormGroup
	 * @param p_form FormGroup
	 */
	public serializeForm(p_formName: string, p_form: AbstractControl) {
		this.storageService.setItem('session', `${this.m_cfgService.SelectedConfigOid}/${p_formName}`, JSON.stringify(p_form.value));
	}

	/**
	 * Erstellt eine FormGroup aus einem JSON-Objekt
	 * @param p_formName Name der FormGroup
	 * @param p_formReference FormGroup
	 */
	private deserializeForm(p_formName: string, p_formReference: AbstractControl) {
		const savedForm = this.storageService.getItem('session', `${this.m_cfgService.SelectedConfigOid}/${p_formName}`);
		if (savedForm) {
			const formValue = JSON.parse(savedForm);
			if (p_formName == this.ORDER_ITEMS) {
				for (let i = 0; i < formValue[this.ITEMS].length; i++) {
					this.createOrderItemFormGroup(formValue);
				}
			}
			p_formReference.patchValue(formValue);
		}
	}

	/**
	 * Liefert die Artikel welche sich im Warenkorb(localStorage) befinden zurück.
	 */
	private getBasketItems() {
		this.m_basketService.basketItems
			.pipe(distinctUntilChanged())
			.pipe(takeUntil(this.m_subscriptionsSubject))
			.subscribe({
				next: (items) => {
					this.getArticleDetails(items);
				}
			});
	}

	/**
	 * Lädt die ArtikelDetails zu den Artikeln aus dem localStorage. Speichert die Artikel in FormArray
	 * @param p_basketItemsFromStorage im lokalStorage befindliche Artikel
	 */
	private getArticleDetails(p_basketItemsFromStorage: ArticleBasketItemByOid.Result[]) {
		const itemsArray = (this.m_orderItems.get(this.ITEMS) as UntypedFormArray);
		itemsArray.clear();
		this.changeDetector.detectChanges();
		if (p_basketItemsFromStorage.length > 0) {
			concat(...p_basketItemsFromStorage.map((basketItem) => this.m_basketService.getArticleBasketDetailsByOid(basketItem.oid, this.m_cfgService.SelectedConfigOid, basketItem.quantity)
				.pipe(catchError((err: HttpErrorResponse) => {
					if (err.status === 500) {
						// Der Warenkorb-Artikel konnte nicht in der Datenbank gefunden werden. Er wird aus dem Warenkorb entfernt.
						this.m_basketService.removeBasketItem(basketItem.oid);
						return of(null);
					}
				}))
			))
				.pipe(takeUntil(this.m_subscriptionsSubject))
				.subscribe({
					next: (articleDetails: ArticleBasketItemByOid.Result) => {
						if (articleDetails != null) {
							itemsArray.push(this.createOrderItemFormGroup(articleDetails));
						}
					},
					complete: () => {
						for (let i = 0; i < (this.m_orderItems.get(this.ITEMS) as UntypedFormArray).controls?.length; i++)
							(this.m_orderItems.get(this.ITEMS) as UntypedFormArray).controls[i].get('quantity').markAsTouched();
					}
				});
		}
	}

	public simulateOrder_Click() {
		this.m_simulateLoading = true;
		this.m_simulatedOrder = null;
		this.serializeForm(this.ORDER_OPTIONS, this.m_orderOptions);
		this.m_zbs.simulateOrder(this.getOrderStruct())
			.pipe(finalize(() => this.m_simulateLoading = false))
			.pipe(take(1))
			.subscribe({
				next: (simulated) => {
					this.m_simulatedOrder = simulated;
				},
				error: (error) => {
					this.m_messageHandlerClass = 'danger';
					this.m_displayError = error;
					this.m_saveOrderClicked = false;
				},
			})
	}

	private getOrderStruct() {
		const orderFormArray = this.getArray();
		const items = [] = orderFormArray.map((el) => {
			return {
				articleOid: el.value.oid,
				qtty: el.value.quantity,
				unitOid: el.value.unitOid,
			}
		});
		const deliveryNameFields = this.m_deliveryForm.value[this.ADDRESS][this.AT_LEAST_ONE];
		let deliveryAddressName = '';
		if (deliveryNameFields[this.COMPANY_NAME_1])
			deliveryAddressName += `${deliveryNameFields[this.COMPANY_NAME_1]}\n`;
		if (deliveryNameFields[this.COMPANY_NAME_2])
			deliveryAddressName += `${deliveryNameFields[this.COMPANY_NAME_2]}\n`;
		if (deliveryNameFields[this.NAME])
			deliveryAddressName += `${deliveryNameFields[this.NAME]}`;

		const invoiceNameFields = this.m_invoiceForm.value[this.ADDRESS][this.AT_LEAST_ONE];
		let invoiceAddressName = '';
		if (invoiceNameFields[this.COMPANY_NAME_1])
			invoiceAddressName += `${invoiceNameFields[this.COMPANY_NAME_1]}\n`;
		if (invoiceNameFields[this.COMPANY_NAME_2])
			invoiceAddressName += `${invoiceNameFields[this.COMPANY_NAME_2]}\n`;
		if (invoiceNameFields[this.NAME])
			invoiceAddressName += `${invoiceNameFields[this.NAME]}`;

		const newOrder: IZbsApp.Order = {
			zbsConfigOid: this.m_cfgService.SelectedConfigOid,
			infoText: this.m_orderOptions.get(this.INFO_TEXT).value,
			customerInfoText: this.m_orderOptions.get(this.CUSTOMER_INFO_TEXT).value,
			dispatchDefinitionOid: this.m_myShippingMethod?.oid,
			paymentMethodProxyOid: this.m_invoiceForm.get(this.PAYMENT_METHOD).value,
			poId: this.m_invoiceForm.get(this.PO_ID).value,
			deliveryDate: this.m_orderOptions.get(this.FIX_DATE).value,
			costCenter1: this.m_userCostCenter,
			costCenter2: this.m_deliveryForm.get(this.COST_CENTER_OID).value,
			verificationCode: this.m_orderOptions.get(this.VERIFICATION_CODE).value,
			isLockedForDelivery: this.m_orderOptions.get(this.IS_LOCKED_FOR_DELIVERY).value,
			zbsValuelistEntryOid: this.m_orderOptions.get(this.ZBS_VALUE_LIST_ENTRY_OID)?.value?.oid,
			deliveryAddress: {
				userAddressOid: this.m_deliveryForm.get(this.ADDRESS_OID).value,
				zbsCustomerOid: this.m_deliveryForm.get(this.CUSTOMER).value,
				name: deliveryAddressName,
				country: this.m_deliveryForm.get(this.ADDRESS).get(this.COUNTRY).value,
				city: this.m_deliveryForm.get(this.ADDRESS).get(this.CITY).value,
				email: this.m_deliveryForm.get(this.ADDRESS).get(this.EMAIL).value,
				zip: this.m_deliveryForm.get(this.ADDRESS).get(this.ZIP).value,
				street: this.m_deliveryForm.get(this.ADDRESS).get(this.STREET).value,
			},
			invoiceCreation: this.m_invoiceForm.get(this.SHOW_INVOICE_FORM).value,
			invoiceAddress: {
				userAddressOid: this.m_invoiceForm.get(this.ADDRESS_OID).value,
				zbsCustomerOid: this.m_invoiceForm.get(this.CUSTOMER).value,
				name: invoiceAddressName,
				country: this.m_invoiceForm.get(this.ADDRESS).get(this.COUNTRY).value,
				city: this.m_invoiceForm.get(this.ADDRESS).get(this.CITY).value,
				email: this.m_invoiceForm.get(this.ADDRESS).get(this.EMAIL).value,
				zip: this.m_invoiceForm.get(this.ADDRESS).get(this.ZIP).value,
				street: this.m_invoiceForm.get(this.ADDRESS).get(this.STREET).value,
			},
			items: items,
		};
		return newOrder;
	}

	/**
	 * Schließt eine Bestellung ab. SaveOrder Request wird ausgeführt.
	 */
	public saveOrder_Submit(): void {
		this.m_saveOrderClicked = true;
		// OrderItems mappen



		this.m_orderService.saveOrder(this.getOrderStruct()).pipe(
			takeUntil(this.m_subscriptionsSubject),
		).subscribe({
			next: (data) => {
				this.storageService.removeItem('session', this.m_cfgService.SelectedConfigOid + '/deliveryForm');
				this.storageService.removeItem('session', this.m_cfgService.SelectedConfigOid + '/invoiceForm');
				this.storageService.removeItem('session', this.m_cfgService.SelectedConfigOid + '/orderItems');
				this.storageService.removeItem('session', this.m_cfgService.SelectedConfigOid + '/orderOptions');
				this.m_basketService.deleteBasket();
				this.m_router.navigate(['./uebersicht']);
			},
			error: (error) => {
				this.m_messageHandlerClass = 'danger';
				this.m_displayError = error;
				this.m_saveOrderClicked = false;
			},
		});
	}



	/**
	 * Die Nachrichten des MessageHandlers werden zurückgesetzt.
	 */
	public clearDisplayMessages(): void {
		this.m_displayError = null;
		this.m_displayMessage = null;
	}

	public getAlternateName(p_alternateName: string): string[] {
		return p_alternateName ? p_alternateName.split('\n') : [];
	}
	/**
	 * Liefert eine URL für ein Thumbnail eines Artikels zurück.
	 * @param p_oid Article OID
	 * @returns die URL des ausgewählten Thumbnails
	 */
	public imageUrl(p_oid: string): string {
		return this.m_articleService.getArticleThumbUrl(p_oid);
	}

	/**
	 * Setzt die ausgewählte Shipping Method.
	 * @param p_oid ShippingMethod OID
	 */
	public shippingMethodSelected(p_oid: string): void {
		if (p_oid) {
			this.m_myShippingMethod = this.m_shippingMethods.find((item) => item.oid == p_oid);
		}
	}

	/**
	 * Setzt den Inhalt einer FormGroup zurück.
	 * @param p_formGroup FormGroup
	 * @param p_controlName FormControlName
	 */
	public clearInput_Click(p_formGroup, p_controlName): void {
		this.getControl(p_formGroup, p_controlName).setValue('');
	}

	/**
	 * Navigiert auf die Artikeldetails eines ausewählten Artikels.
	 * @param p_oid Article OID
	 */
	public articleDetails_Click(p_oid: string) {
		this.m_router.navigate(['/artikel/details', p_oid]);
	}

}
